import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=820def04&scoped=true"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"
import style0 from "./voucher.vue?vue&type=style&index=0&id=820def04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820def04",
  null
  
)

export default component.exports